import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../../../components/MainLayout';
import { PagesHeader } from '../../../../components/shared/PagesHeader';
import { ROUTES } from './ResolveFailure.config';
import { Formik } from 'formik';
import { resolveFailureValidationSchema } from '../../config/validation';
import { resolveFailureInitialValues } from '../../config/initialValues';
import { resolveFailureFormConfig } from './formConfig';
import { useLocation } from 'react-router-dom';
import TechnicalFailureForm from '../../components/TechnicalFailureForm/TechnicalFailureForm';
import ResolveFailureDialog from '../../components/ResolveFailureDialog/ResolveFailureDialog';
import { resolveTechnicalFailure } from '../../../../services/apis';
import styles from './ResolveFailure.styles.scss';

const ResolveFailure = () => {
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resolveRes, setResolveRes] = useState();

  return (
    <MainLayout className={styles.resolveFailure} eInvoicing={true}>
      <PagesHeader withBreadcrumb={true} routes={ROUTES(state)} />
      <div className={styles.container}>
        <h1>
          {state.readOnly
            ? t('failure_notification.technical_failure_item_details', {
                number: state?.data?.failureReferenceNumber,
              })
            : t('failure_notification.resolve_technical_failure')}
        </h1>
        <Formik
          validateOnMount
          enableReinitialize
          validationSchema={resolveFailureValidationSchema({
            t,
          })}
          initialValues={resolveFailureInitialValues(state?.data)}
          onSubmit={(values) => {
            setLoading(true);
            resolveTechnicalFailure(values)
              .then(({ data }) => {
                setResolveRes(data);
                setShowDialog(true);
              })
              .finally(() => {
                setLoading(false);
              });
          }}
        >
          {({ values, errors, touched, setFieldValue, setTouched }) => {
            return (
              <TechnicalFailureForm
                values={values}
                loading={loading}
                errors={errors}
                touched={touched}
                submitLabel={t('common.submit')}
                readOnly={state?.readOnly}
                cancelLabel={
                  state.readOnly ? t('common.back') : t('common.cancel')
                }
                formConfig={resolveFailureFormConfig({
                  t,
                  lang: i18n.language,
                  values,
                  setTouched,
                  setFieldValue,
                  readOnly: state?.readOnly,
                })}
              />
            );
          }}
        </Formik>
        <ResolveFailureDialog
          isOpen={showDialog}
          setIsOpen={setShowDialog}
          referenceNumber={resolveRes?.failureReferenceNumber}
        />
      </div>
    </MainLayout>
  );
};

export default ResolveFailure;
